import { NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import WebService from "../../Services/WebService";
import "./menu.scss";
// icons (same imports you already had)
import iconReview from "../../assets/images/home.svg";
import userIcon from "../../assets/images/users.svg";
import CourseIcon from "../../assets/images/course.svg";
import paymentIcon from "../../assets/images/payment.svg";
import settingicon from "../../assets/images/setting.svg";
import icon3 from "../../assets/images/certifications.svg";
import icon4 from "../../assets/images/study.svg";
import icon5 from "../../assets/images/subscription.svg";
import certificate from "../../assets/images/certificate.svg";
import customers from "../../assets/images/customers.svg";
import Airports from "../../assets/images/Airport.svg";
import Email from "../../assets/images/email.svg";
import webHome from "../../assets/images/home.svg";
import webFlight from "../../assets/images/flights.svg";
import ExamVideo from "../../assets/images/videocall.svg";
import ContactUsIcon from "../../assets/images/contactus.svg";
import CountriesIcon from "../../assets/images/country.svg";
import DiscountIcon from "../../assets/images/discount.svg";
interface MenuItem {
  title: string;
  url: string | null;
  icon_class: string;
  child?: MenuItem[];
}

interface ApiResponse {
  message: string;
  status: string;
  list: MenuItem[];
}

const VerticalMenu = () => {
  const [menus, setMenus] = useState<MenuItem[]>([]);
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  // USER TYPE
  const rawType = localStorage.getItem("type") || "ADMIN";
  const userType =
    rawType.toUpperCase() === "USER" ? "WEBSITE" : rawType.toUpperCase();

  const [userData, setUserData] = useState<any>(null);
  const location = useLocation();

  const userCountryName = userData?.country?.name;
  //const userCountryAccess = userData?.country?.certification_enabled;
  const getUserCountryAccess = () => {
    const raw = localStorage.getItem("UserData");
    if (!raw) return null;

    try {
      const parsed = JSON.parse(raw);
      return parsed?.country?.certification_enabled;
    } catch {
      return null;
    }
  };

  useEffect(() => {
    getLeftMenus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    console.log("userData", userData);
  }, [userType]);

  useEffect(() => {
    const handler = () => {
      getLeftMenus();
    };

    window.addEventListener("PROFILE_UPDATED", handler);
    return () => window.removeEventListener("PROFILE_UPDATED", handler);
  }, []);

  const getLeftMenus = async () => {
    try {
      const res = await WebService.getAPI({
        action: `/left-menus?type=${userType}`,
      });

      const data = res as ApiResponse;

      if (data?.status === "Success") {
        let filteredMenus = data.list;
        const countryAccess = getUserCountryAccess();

        if (userType === "WEBSITE" && countryAccess !== 1) {
          filteredMenus = filteredMenus.filter(
            (menu) => menu.title !== "Certification Course",
          );
        }

        setMenus(filteredMenus);
      }
    } catch (error) {
      console.error("Error fetching menu:", error);
    }
  };

  // ICON MAPPING
  const getMenuIcon = (title: string) => {
    const adminIconMap: Record<string, string> = {
      Dashboard: iconReview,
      "Manage Admin Users": userIcon,
      "Manage Roles": icon3,
      "Manage Subscription": icon5,
      "Manage Customers": customers,
      "Manage Examiners": customers,
      "Manage Exam Bookings": CourseIcon,
      "Manage Payments": paymentIcon,
      "Manage Airports": Airports,
      Settings: settingicon,
      "Manage CMS": icon3,
      "Manage Certification course": certificate,
      "Trainer Manager": CourseIcon,
      "Study Materials": icon4,
      "Email Templates": Email,
      "Examiner Payments": paymentIcon,
      "Exam Questions": CourseIcon,
      "Contact Us": ContactUsIcon,
      "Manage Countries": CountriesIcon,
      "Manage Simulators": CourseIcon,
      "Manage Discount Codes" : DiscountIcon
    };

    const websiteIconMap: Record<string, string> = {
      Home: webHome,
      Training: CourseIcon,
      "Simulator Flight": webFlight,
      "Certification Course": certificate,
      "Study Materials": icon4,
      "My Subscriptions": icon5,
    };

    const examinerIconMap: Record<string, string> = {
      Home: webHome,
      "Exam Managements": CourseIcon,
      "Exam Console": ExamVideo,
      Payments: paymentIcon,
      Settings: settingicon,
    };

    if (userType === "ADMIN") return adminIconMap[title] || iconReview;
    if (userType === "WEBSITE") return websiteIconMap[title] || webHome;
    if (userType === "EXAMINER") return examinerIconMap[title] || webHome;
    return iconReview;
  };

  // toggle expand/collapse for a parent menu
  const toggle = (index: number) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  const handleMenuClose = () => {
    document.body.classList.remove("show-mo-menu");
  };

  return (
    <div id="vertical_menu" className="verticle-menu collapsed-menu">
      <div className="menu-list">
        {menus.length > 0 ? (
          menus.map((menu, index) => {
            const hasChildren =
              Array.isArray(menu.child) && menu.child.length > 0;
            const isParentActive =
              menu.child?.some(
                (sub) => sub.url && location.pathname.startsWith(sub.url),
              ) || false;
            return (
              <div
                key={index}
                className={`menu-row ${hasChildren ? "has-child" : ""}`}
              >
                {/* Parent - If it has children we render a button to toggle, not a NavLink */}
                {hasChildren ? (
                  <div
                    className={`menu-item parent-item ${
                      openIndex === index || isParentActive ? "open active" : ""
                    }`}
                    // keyboard accessibility: allow Enter/Space to toggle
                    role="button"
                    tabIndex={0}
                    onClick={() => toggle(index)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter" || e.key === " ") toggle(index);
                    }}
                    aria-expanded={openIndex === index}
                  >
                    <div className="left">
                      <img
                        src={getMenuIcon(menu.title)}
                        alt=""
                        className="menu-icon"
                      />
                      <span className="menu-title">{menu.title}</span>
                    </div>

                    {/* Expand button / arrow bigger and clickable */}
                    <button
                      className={`expand-btn ${
                        openIndex === index ? "rotated" : ""
                      }`}
                      onClick={(e) => {
                        e.stopPropagation();
                        toggle(index);
                      }}
                      aria-label={
                        openIndex === index
                          ? `Collapse ${menu.title}`
                          : `Expand ${menu.title}`
                      }
                    >
                      {/* simple caret character — styled in SCSS */}
                      <span className="caret">
                        <svg
                          className="caret-svg"
                          width="20"
                          height="20"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="#999"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="6 9 12 15 18 9" />
                        </svg>
                      </span>
                    </button>
                  </div>
                ) : (
                  <NavLink
                    to={menu.url || "#"}
                    className={({ isActive }) =>
                      `menu-item ${isActive ? "active" : ""}`
                    }
                    onClick={handleMenuClose}
                  >
                    <img
                      src={getMenuIcon(menu.title)}
                      alt={`${menu.title} icon`}
                      className="menu-icon"
                    />
                    <span className="menu-title">{menu.title}</span>
                  </NavLink>
                )}

                {/* Submenu (collapsible) */}
                {hasChildren && openIndex === index && (
                  <div className="submenu">
                    {menu.child!.map((sub, subIndex) => (
                      <NavLink
                        key={subIndex}
                        to={sub.url || "#"}
                        className={({ isActive }) =>
                          `submenu-item ${isActive ? "active" : ""}`
                        }
                        onClick={handleMenuClose}
                      >
                        <img
                          src={getMenuIcon(menu.title)}
                          alt=""
                          className="menu-icon"
                        />
                        <span className="submenu-title">{sub.title}</span>
                      </NavLink>
                    ))}
                  </div>
                )}
              </div>
            );
          })
        ) : (
          <div className="text-center p-3">Loading menus...</div>
        )}
      </div>
    </div>
  );
};

export default VerticalMenu;
